module.exports = __webpack_public_path__ + "static/img/about_img_support.ee34b7f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/guanyu/about_img_support.png
// module id = Opnz
// module chunks = 1